export * from './adherentResource.service';
import { AdherentResourceService } from './adherentResource.service';
export * from './adhesionEluResource.service';
import { AdhesionEluResourceService } from './adhesionEluResource.service';
export * from './adhesionEnLigneAuthResource.service';
import { AdhesionEnLigneAuthResourceService } from './adhesionEnLigneAuthResource.service';
export * from './adhesionEnLigneNoAuthResource.service';
import { AdhesionEnLigneNoAuthResourceService } from './adhesionEnLigneNoAuthResource.service';
export * from './conditionsGeneralesResource.service';
import { ConditionsGeneralesResourceService } from './conditionsGeneralesResource.service';
export * from './demandeResource.service';
import { DemandeResourceService } from './demandeResource.service';
export * from './documentationAuthResource.service';
import { DocumentationAuthResourceService } from './documentationAuthResource.service';
export * from './documentationResource.service';
import { DocumentationResourceService } from './documentationResource.service';
export * from './donneesPersonnellesResource.service';
import { DonneesPersonnellesResourceService } from './donneesPersonnellesResource.service';
export * from './downloadResource.service';
import { DownloadResourceService } from './downloadResource.service';
export * from './emailValidationResource.service';
import { EmailValidationResourceService } from './emailValidationResource.service';
export * from './recaptchaValidationResource.service';
import { RecaptchaValidationResourceService } from './recaptchaValidationResource.service';
export * from './utilsResource.service';
import { UtilsResourceService } from './utilsResource.service';
export const APIS = [AdherentResourceService, AdhesionEluResourceService, AdhesionEnLigneAuthResourceService, AdhesionEnLigneNoAuthResourceService, ConditionsGeneralesResourceService, DemandeResourceService, DocumentationAuthResourceService, DocumentationResourceService, DonneesPersonnellesResourceService, DownloadResourceService, EmailValidationResourceService, RecaptchaValidationResourceService, UtilsResourceService];
